import {Component, Input, LOCALE_ID, OnInit} from '@angular/core';
import {CalendarDateFormatter, CalendarEvent} from 'angular-calendar';
import {ActivatedRoute, Router} from '@angular/router';
import {CalendarView} from 'angular-calendar/modules/common/calendar-view.enum';

import {registerLocaleData} from '@angular/common';
import localeUk from '@angular/common/locales/uk';
import {CustomDateFormatter} from './custom-date-formatter.provider';

registerLocaleData(localeUk);

@Component({
    selector: 'app-tracker-calendar',
    templateUrl: './tracker-calendar.component.html',
    styleUrls: ['./tracker-calendar.component.scss'],
    providers: [
        {
            provide: CalendarDateFormatter,
            useClass: CustomDateFormatter
        },
        {
            provide: LOCALE_ID, useValue: 'uk'
        }
    ]
})
export class TrackerCalendarComponent implements OnInit {
    @Input() sessions: any[] = [];
    @Input() session: any;
    events: CalendarEvent[] = [];

    view: CalendarView | 'month' | 'week' | 'day' = 'month';
    locale = 'uk';

    viewDate: Date = new Date();
    showSelector = null;

    currentSession = null;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.currentSession = this.route.snapshot.params.sid;
        this.viewDate = this.session?.createdAt?.seconds ? this.convertDate(this.session?.createdAt?.seconds) : new Date();
        this.sessions.filter(el => el.state !== 'failed').forEach((el) => {
            const dateFromNanoseconds = this.convertDate(el.recordedAt.seconds);
            this.events.unshift({
                start: dateFromNanoseconds,
                title: el.test,
                id: el.id,
                color: {
                    primary: this.selectColor(el, 'primary'),
                    secondary: this.selectColor(el, 'secondary'),
                },
            });

        });
    }

    showCalendar(e: any) {
        e.preventDefault();
        e.stopPropagation();
        this.showSelector = null;
    }

    isActiveDate(day) {

        const date1 = new Date(day.date).setHours(0, 0, 0, 0);
        const date2 = new Date().setHours(0, 0, 0, 0);
        return date1 === date2;
    }

    onDayClick(day) {
        const events = day.events.length;
        if (events) {
            if (events === 1) {
                this.onSelect(day.events[0].id);
            } else {
                this.showSelector = day.date;
            }
        }
        return;
    }

    onSelect(id) {
        this.router.navigate(['s', id, 'r']);
    }

    translateTestName(prop) {
        switch (prop) {
            case 'anxiety':
                return 'тривоги';
            case 'depression':
                return 'депресії';
            case 'mixed':
                return 'стресу/вигорання';
            default:
                return 'тривога';

        }
    }

    getWeekDay(i: number) {
        const days = ['s', 'm', 't', 'w', 't', 'f', 's'];
        return days[i];
    }

    selectColor(data: { test: 'depression' | 'anxiety' | 'mixed', detailsData: any }, type: 'primary' | 'secondary'): any {
        let minColor = '#EEF300';
        let midColor = '#83dfb9';
        const maxColor = '#ffa794';

        if (data.test === 'depression') {
            minColor = '#83dfb9';
            midColor = '#EEF300';
        }

        let valueField = 'performanceScore';
        let segmentsField = 'performanceScoreSegments';
        if (data.test !== 'mixed') {
            if (type === 'primary') {
                valueField = 'attentionalBiasScore';
                segmentsField = 'attentionalBiasScoreSegments';
            } else {
                valueField = 'formsScore';
                segmentsField = 'formsScoreSegments';
            }
        }

        const value = data?.detailsData.hasOwnProperty(valueField) ? data.detailsData[valueField] : null;
        const segments = data?.detailsData.hasOwnProperty(segmentsField) ? data.detailsData[segmentsField] : null;
        if (value == null || segments == null) {
            return '#805FFF'; // data.test === 'mixed' ? '#805FFF' : 'red';
        }

        return value <= segments[0] ? minColor
            : value <= segments[1] ? midColor
                : maxColor;
    }

    convertDate(seconds): Date {
        const milliseconds = Math.floor(seconds * 1000);
        const dateFromNanoseconds = new Date(milliseconds);
        const unixEpoch = new Date(0); // The Unix epoch
        return new Date(dateFromNanoseconds.getTime() + unixEpoch.getTime());
    }

    generateCircle(color: any) {
        return `linear-gradient(90deg, ${color?.primary}, ${color?.primary}, 50%, ${color?.secondary} 50%, ${color?.secondary} )`;
    }
}
